<div class="d-flex justify-content-between bd-highlight topbar">
  <!-- Sección izquierda de la barra superios -->
  <div class="bd-highlight">
    <div class="d-flex justify-content-start align-items-center bd-highlight">
      <!-- <div class="bd-highlight">
        <app-topbar-search></app-topbar-search>
      </div> -->
      <div class="bd-highlight">
        <!-- <app-topbar-fav-pages></app-topbar-fav-pages> -->
      </div>
    </div>
  </div>
  <!-- Sección media de la barra superior
  <div class="bd-highlight">
    <div class="d-flex justify-content-center align-items-center bd-highlight">
      <div class="bd-highlight">
        <app-topbar-project-management></app-topbar-project-management>
      </div>
      <div class="bd-highlight">
        <app-topbar-language-switcher></app-topbar-language-switcher>
      </div>
    </div>
  </div -->
  <!-- Sección derecha de la barra superios -->
  <div class="bd-highlight">
    <div class="d-flex justify-content-end align-items-center bd-highlight">
      <div class="pe-2 bd-highlight">
        <app-topbar-notifications></app-topbar-notifications>
      </div>
      <!-- <div class="pe-2 bd-highlight">
        <app-topbar-messages></app-topbar-messages>
      </div> -->
      <div class="pe-2 bd-highlight">
        <app-topbar-terminal></app-topbar-terminal>
      </div>
      <div class="pe-2 bd-highlight">
        <h6><strong>{{ userName }}</strong></h6>
      </div>
      <div class="pe-2 bd-highlight">
        <app-topbar-user-menu></app-topbar-user-menu>
      </div>
    </div>
  </div>
</div>